import * as React from 'react';
import { Component } from 'react';
import { NavMenu } from '../NavMenu/NavMenu';
import { IProfileInfo } from '../../models/IProfileInfo';
import { connect } from 'react-redux';
import GlobalStatusBarComponent, { ShowStatusBar } from './GlobalStatusBar';
import './Layout.css';
import { RouteComponentProps, withRouter } from 'react-router';
import Cookies from 'universal-cookie';
import { CookieInfoComponent } from './CookieInfo';
import GlobalLoginModalComponent from './GlobalLoginModal';
import { AcceptStatuteModalComponent } from './AcceptStatuteModal';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { TemporaryComponent } from './Temporary';
import Helmet from 'react-helmet';
import { ARTICLES } from "../Blog/Articles/Articles";

let UNAUTHORIZED_ROUTES = [
    '/login'
]

export function RedirectWithRouter(to: string) {
    if (layoutComponent !== null) {
        layoutComponent.RedirectWithRouter(to);
    }
}

let layoutComponent: Layout | null = null;

function MapState(state) {
    return {
        ProfileInfo: state.Profile
    }
}

interface IProps extends RouteComponentProps<any> {
    ProfileInfo: IProfileInfo
}

interface IState {
    SearchVisible: boolean,
    CookieInfoVisible: boolean,
    AcceptStatuteModalVisible: boolean
}

class Layout extends Component<IProps, IState> {

    private controlPanelHrefList = [
        '/physiotherapist/edit',
        '/scheduler',
        '/visit/list',
        '/favorite/list',
        '/customer/account/edit',
        '/myvisits',
        '/visit/view'
    ];

    constructor(props) {
        super(props);

        let cookie = new Cookies();
        let cookiesAccepted = cookie.get("COOKIES_ACCEPTED") as string;
        let cookieInfoVisible = true;
        if (cookiesAccepted !== undefined) {
            if (cookiesAccepted.toLocaleLowerCase() === "true") {
                cookieInfoVisible = false;
            } else {
                cookieInfoVisible = true;
            }
        } else {
            cookieInfoVisible = true;
        }

        this.state = {
            SearchVisible: false,
            CookieInfoVisible: cookieInfoVisible,
            AcceptStatuteModalVisible: (this.props.location.pathname.indexOf('statute') !== -1 ? true : false)
        }

        this.ToggleSearch = this.ToggleSearch.bind(this);
        this.OnCookieOkClick = this.OnCookieOkClick.bind(this);
        this.OnStatuteAccept = this.OnStatuteAccept.bind(this);
        this.OnStatuteAbort = this.OnStatuteAbort.bind(this);
    }

    public componentWillMount() {
        this.props.history.listen(this.OnHistoryChange.bind(this, location));
        layoutComponent = this;
    }

    public componentWillUnmount() {
        layoutComponent = null;
    }

    public componentWillReceiveProps(nextProps: IProps) {

    }

    public render() {

        let tmp = true;
        if (tmp) {
            return this.renderLayout()
        } else {
            if (this.props.ProfileInfo.Role === "Physiotherapist" ||
                this.props.ProfileInfo.Role === "Admin" ||
                this.state.AcceptStatuteModalVisible === true
            ) {
                return this.renderLayout();
            }
            else {
                if (UNAUTHORIZED_ROUTES.find((element) => this.props.location.pathname.indexOf(element) !== -1)) {
                    return this.renderLayout();
                } else {
                    return (<TemporaryComponent />);
                }
            }
        }
    }

    public renderLayout() {
        const foundArticle = ARTICLES.find(item => this.props.location.pathname.includes(item.path));
        return (
            <div className={this.GetApplicationClass() + (this.state.SearchVisible ? ' search-visible' : '')}>
                {foundArticle ?
                    <Helmet>
                        <meta content="Znajdz fizjoterapeute" name="description" />
                        <meta content="KIF" name="author" />
                        <meta property="og:title" content={foundArticle.title} />
                        <meta property="og:description" content={foundArticle.title} />
                        <meta property="og:url" content={`https://znajdzfizjoterapeute.pl/blog/${foundArticle.path}`} />
                        <meta property="og:image" content={`https://znajdzfizjoterapeute.pl/images/blog/${foundArticle.sliderImg}`} />
                        <meta property="og:image:width" content="346" />
                        <meta property="og:image:height" content="230" />
                    </Helmet>
                    :
                    <Helmet>
                        <meta name="title" content={"Znajdź Fizjoterapeutę - wyszukiwarka fizjoterapeutów w Twojej okolicy"} />
                        <meta name="description" content={"Znajdź zaufanego fizjoterapeutę w Twojej okolicy i umów wizytę w dogodnym terminie. Najbardziej aktualna baza fizjoterapeutów z prawem wykonywania zawodu."} />
                    </Helmet>
                }
                {this.RenderAcceptStatuteModal()}
                <GlobalStatusBarComponent />
                <GlobalLoginModalComponent />
                <div className={`menu menu-${this.GetMenuClass()}`}>
                    <NavMenu ProfileInfo={this.props.ProfileInfo} SearchToggle={this.ToggleSearch} />
                </div>
                <div className={'page-content'}>
                    {this.props.children}
                </div>
                {this.RenderCookieInfo()}
            </div>
        );
    }

    public RedirectWithRouter(to: string) {
        this.props.history.push(to);
    }

    private RenderAcceptStatuteModal() {
        if (this.state.AcceptStatuteModalVisible) {
            return (
                <AcceptStatuteModalComponent
                    OnStatuteAccept={this.OnStatuteAccept}
                    OnStatuteAbort={this.OnStatuteAbort} />
            );
        } else {
            return null;
        }
    }

    private OnStatuteAccept() {
        this.setState({
            AcceptStatuteModalVisible: false
        });
        if (window.location.href.indexOf('customer') !== -1) {
            this.props.history.push('/myvisits');
        } else {
            ShowStatusBar('Info', 'Witamy w serwisie! Uzupełnij swoje dane.', DEFAULT_STATUS_TIMEOUT * 2);
            this.props.history.push('/physiotherapist/edit');
        }
    }

    private OnStatuteAbort() {
        this.setState({
            AcceptStatuteModalVisible: false
        });
        if (window.location.href.indexOf('customer') !== -1) {
            this.props.history.push('/');
        } else {
            window.location.href = 'https://logowanie.kif.info.pl/app/choose';
        }
    }

    private RenderCookieInfo() {
        if (this.state.CookieInfoVisible) {
            return (
                <CookieInfoComponent OnAccept={this.OnCookieOkClick} />
            );
        } else {
            return null;
        }
    }

    private OnHistoryChange(location) {
        if (this.props.history.action === "POP") {
            return;
        } else {
            window.scrollTo(0, 0);
        }
    }

    private GetApplicationClass(): string {
        if (this.props.ProfileInfo.Role === "Physiotherapist") {
            if (this.IsControlPanelSite()) {
                return 'application control-panel';
            } else {
                return 'application control-panel control-panel-scroll';
            }
        }
        if (this.props.ProfileInfo.Role === "Customer") {
            if (this.IsControlPanelSite()) {
                return 'application control-panel';
            } else {
                return 'application control-panel control-panel-scroll';
            }
        }
        if (this.props.ProfileInfo.Role === "Admin") {
            if (this.IsControlPanelSite()) {
                return 'application control-panel';
            } else {
                return 'application control-panel control-panel-scroll';
            }
        }
        this.IsControlPanelSite();
        return 'application';
    }

    private IsControlPanelSite(): boolean {
        for (let href of this.controlPanelHrefList) {
            if (this.props.location.pathname.indexOf(href) !== -1) {
                return true;
            }
        }
        return false;
    }

    private GetMenuClass(): string {
        const currentPage = this.props.location.pathname.split('/');
        if (currentPage[1] === "physiotherapist") {
            return `${currentPage[1]}-${currentPage[2]}`
        }
        if (currentPage[1] === "") {
            return "mainpage"
        }
        return currentPage[1];
    }

    private ToggleSearch() {
        this.setState({
            SearchVisible: !this.state.SearchVisible
        });
    }

    private OnCookieOkClick() {
        let cookie = new Cookies();
        let expireDate = new Date();
        expireDate.setFullYear(expireDate.getFullYear() + 1);
        cookie.set("COOKIES_ACCEPTED", true, {
            expires: expireDate
        });
        this.setState({
            CookieInfoVisible: false
        });
    }
}

export default withRouter(connect(MapState)(Layout));


// WEBPACK FOOTER //
// ./src/components/Layout/Layout.tsx